import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class ApplicationTypeService extends CrudService {
  constructor() {
    super('applicationTypes')
  }
}

export default ApplicationTypeService
